export const OSTRO_STORAGE_CHANGE_EVENT_NAME = 'ostroStorageChanged';
